import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';
import { TransactionDetailFields as tdf } from '../../../types';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '交易时间',
            dataIndex: tdf.transactionTime,
            key: tdf.transactionTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '账户外部编号',
            dataIndex: tdf.accountOutId,
            key: tdf.accountOutId,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '账户名称',
            dataIndex: tdf.accountName,
            key: tdf.accountName,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '子账户名称',
            dataIndex: tdf.subAccountName,
            key: tdf.subAccountName,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '交易名称',
            dataIndex: tdf.transactionName,
            key: tdf.transactionName,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '收支类型',
            dataIndex: tdf.incomeDrawType,
            key: tdf.incomeDrawType,
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '交易金额（元）',
            dataIndex: tdf.transactionMoney,
            key: tdf.transactionMoney,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '交易后余额（元）',
            dataIndex: tdf.transactionBalance,
            key: tdf.transactionBalance,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '支付订单号',
            dataIndex: tdf.payOrderId,
            key: tdf.payOrderId,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '业务订单号',
            dataIndex: tdf.businessOrderId,
            key: tdf.businessOrderId,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '业务来源',
            dataIndex: tdf.businessSource,
            key: tdf.businessSource,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        }
    ]);

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    showAudit: PropTypes.bool,
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;